// extracted by mini-css-extract-plugin
export default {"container":"Attachment__container___hyycf"};